import React from "react";
import { AUDITS } from "../../../core/theme/auditsTheme";

// TEMPORARY (B2 stage 2): the niche roll-up as plain text, so the counts can
// be checked against the SQL check query. Stage 3 replaces it with the
// Industry Audit panel (rings, numbers, graphs).
export default function NicheCountsCheck({ state }) {
  if (state.status === "loading") return <p className={AUDITS.checkMuted}>Loading niche counts…</p>;
  if (state.status === "error") {
    return <p className={AUDITS.checkWarning}>The niche counts couldn't be loaded. Your Snapshots are unaffected.{seconds(state.ms)}</p>;
  }

  const { rollup } = state;
  return (
    <div className="space-y-3">
      {rollup.targetsLoaded ? (
        <p className={AUDITS.checkMuted}>
          Unlock targets: {n(rollup.targets.searches)} searches · {n(rollup.targets.keywords)} keywords · {n(rollup.targets.locations)} locations
        </p>
      ) : (
        <p className={AUDITS.checkWarning}>The unlock targets couldn't be loaded, so every niche shows as locked.</p>
      )}
      {!rollup.complete && <p className={AUDITS.checkWarning}>Some rows didn't load, so these counts may be short.</p>}
      {rollup.niches.length === 0 && <p className={AUDITS.checkMuted}>No Snapshots with a niche yet.</p>}
      {rollup.niches.map(niche => (
        <div key={niche.nicheId} className={AUDITS.checkNiche}>
          <p className="font-semibold text-slate-800">
            {niche.name} · {niche.unlocked ? "Unlocked" : "Building"}
            {niche.furthest && <span className="font-normal text-slate-500"> · furthest: {niche.furthest}</span>}
          </p>
          <p>
            {n(niche.searches)} searches{niche.estimated ? " (estimated)" : ""} · {n(niche.keywords)} keywords · {n(niche.locations)} locations
            {niche.progress && ` (targets ${pct(niche.progress.searches)}, ${pct(niche.progress.keywords)}, ${pct(niche.progress.locations)})`}
          </p>
          <p>
            {n(niche.advertisers)} advertisers · {niche.snapshots} Snapshots · insight since {date(niche.insightSince)}
          </p>
          <p>
            Gathering now: {niche.gatheringNow} · last 7 days: {n(niche.searchesThisWeek)} searches · on the map: {niche.locationsCovered.length} of {niche.locations} locations
          </p>
        </div>
      ))}
      <p className={AUDITS.checkMuted}>Loaded in{seconds(state.ms)}</p>
    </div>
  );
}

const n = value => Number(value || 0).toLocaleString("en-GB");
const pct = p => `${Math.floor(p.percent * 100)}%`;
const seconds = ms => (ms == null ? "" : ` ${(ms / 1000).toFixed(1)} s`);
const date = iso => (iso ? new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
